import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useAuth } from "../../auth/AuthProvider";
import { searchUser } from "../../../controllers/user";
import { useNavigate } from "react-router-dom";

export default function BuscarMiembro () {
  const { token } = useAuth();
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    console.log('selected user', user);
    if (user) {
      navigate(`/app/members/${user[0].user_id}`);
    }
  }

  async function handleSearch(query) {
    if (query.length < 5) {
      return;
    }
    console.log(`query: ${query}`);
    setIsLoading(true);
    const search = encodeURIComponent(query);
    let r = await searchUser(token, search);
    setOptions(r);
    setIsLoading(false);
  }

  function renderUserOption(option) {
    return <span>{option.title}</span>;
  }
  const filterBy = () => true;

  return <Form onSubmit={handleSubmit}>
    <Form.Group className="mb-3 mt-2">
        <Form.Label>Nombre o email</Form.Label>
        <AsyncTypeahead
        filterBy={filterBy}
        id="async-example"
        isLoading={isLoading}
        labelKey="title"
        minLength={3}
        onSearch={handleSearch}
        onChange={setUser}
        options={options}
        placeholder="Nombre o email"
        renderMenuItemChildren={renderUserOption}
      />
      </Form.Group>
      <Button key='submit-btn' type='submit' variant='primary'>Ver miembro</Button>
  </Form>;
}